import type { CuriosityParams } from '@/app/components/search/Curiosity';
import type { CommonData } from '@/app/common/createCommonData.ts';
import type { Localization } from '@/app/components/search/common/Localization.ts';

type ShowDebugContentParams = {
  commonData: CommonData;
  localization: Localization;
  curiosityParams: CuriosityParams;
};
export const createShowDebugContent = ({ commonData, localization, curiosityParams }: ShowDebugContentParams) =>
  curiosityParams.isDev || curiosityParams.isQa || localization.isTelesales || commonData.authenticated;

// The memsearch URL carries an internal host and the whole upstream query string, so it is produced
// only for a viewer who would actually be shown it: debug switched on for the page AND the same
// authorisation the banner applies to its contents. `&debug=true` is a public switch (CLAUDE.md), so
// the switch on its own is not enough. (MPH-1139)
export const createShowDebugApiUrl = (params: ShowDebugContentParams) =>
  params.curiosityParams.debugEnabled && createShowDebugContent(params);
